import Vue, { ref } from 'vue';
import StaticCommentsView from '@fr/pages/desktop/application/hotel/index/staticComments/StaticComments';
import { HotelReviews, getHotelReviews, MAX_SIZE_REVIEWS } from '@widgets/hotelReviews';
import getTopHotelsAvailable from '@/js/common/services/getTopHotelsAvailable';
import noReviewTopHotelsTemplate from './noReviewTopHotels.html';

import './reviews.scss';

class HotelPageReviewsView extends Backbone.Epoxy.View {
    initialize() {
        this.initDefaultState();
        this.initModules();
        this.initTabEvents();
        this.initDefaultActiveTabs();
        this.deleteTopHotels();
    }

    initDefaultState() {
        this.topHotelReviewsLoaded = false;
        this.travelataLoaded = false;
        this.tripAdvisorData = ref(null);
        this.tripAdvisorRendered = false;
        this.isTopHotelAvailable = getTopHotelsAvailable();
    }

    initModules() {
        this.loadTripAdvisorHotelReviews();

        this.$loader = $('#reviews_tophotels .tophotelsLoader');
        this.$reviewsTabs = $('#reviewsTabs');
        this.$tophotelsFrame = $('#reviews_tophotels .frame');
        this.ourReviews = new StaticCommentsView({
            el: '#reviews_our',
        });
    }

    deleteTopHotels() {
        if (this.isTopHotelAvailable) {
            return;
        }

        const topHotelsLogo = document.querySelector('.tophotelsLogo')?.closest('li');
        const topHotelsContainer = document.querySelector('#reviews_tophotels');

        if (topHotelsLogo && topHotelsContainer) {
            topHotelsLogo.style.display = 'none';
            topHotelsContainer.style.display = 'none';
        }

        const nameSourceReview = window.appConfig?.hotelInfo?.reviewsSource;
        const nameSourceReviewWithoutTopHotels = nameSourceReview === 'topHotels'
            ? 'travelata'
            : nameSourceReview;

        const activeReviewsOnNameSource = {
            'travelata': { active: 1 },
            'tripadvisor': { active: 2 },
        };

        this.$reviewsTabs.tabs(activeReviewsOnNameSource[nameSourceReviewWithoutTopHotels]);
        this.$reviewsTabs.trigger('tabsactivate');
    }

    async loadTripAdvisorHotelReviews() {
        const options = {
            limit: MAX_SIZE_REVIEWS * 2,
            hotelId: window.appConfig.hotelInfo?.id,
            page: 1,
        };

        const res = await getHotelReviews(options);

        if (res.reviews?.length) {
            this.tripAdvisorData.value = res;
        } else {
            this.hideTripAdvisorTab();
        }
    }

    hideTripAdvisorTab() {
        this.$el.find("li").eq(2).hide();
    }

    renderTripAdvisor() {
        if (this.tripAdvisorRendered) {
            return;
        }

        new Vue({
            render: (h) => h(HotelReviews, {
                props: {
                    hotelId: window.appConfig.hotelInfo?.id,
                    initialHotelReview: this.tripAdvisorData.value,
                }
            }),
        }).$mount('.js-block-tripadviser');

        this.tripAdvisorRendered = true;
    }

    async loadTravelataReviews() {
        if (this.travelataLoaded) {
            return;
        }

        await this.ourReviews.loadData();
        this.travelataLoaded = true;
    }

    async loadTopHotelsReviews() {
        if (this.topHotelReviewsLoaded || !this.isTopHotelAvailable) {
            return;
        }

        try {
            const tophotelsScript = await this.getTopHotelsScript()
            this.$tophotelsFrame.html(tophotelsScript);
            this.topHotelReviewsLoaded = true;
        } catch (noReviewsTemplate) {
            $('#reviews_tophotels').html(noReviewsTemplate);
        }
    }

    initTabEvents() {
        this.$reviewsTabs.on('tabsactivate', () => {
            const activeTab = this.$reviewsTabs.tabs('option', 'active');

            switch(activeTab) {
                case 0: {
                    this.loadTopHotelsReviews();
                    break;
                }
                case 1: {
                    this.loadTravelataReviews()
                    break;
                }
                case 2: {
                    this.renderTripAdvisor();
                    break;
                }
            }
        });
    }

    getTopHotelsScript() {
        return new Promise((res, rej) => {
            const getReviewsURL = `${window?.appConfig?.gatewayUrl}/apiV1/hotel/getTopHotelsReviews?id=${window?.appConfig?.hotelInfo?.id}`;
            jQuery.ajax({
                url: getReviewsURL,
                type: 'POST',
            })
            .done((response) => {
                const result = response?.data;
                if (response?.success === true && result) {
                    res(result);
                    return;
                }
                this.$reviewsTabs.tabs('disable', 0);
                rej(noReviewTopHotelsTemplate);
            })
            .always(() => {
                this.$loader.hide();
            });
        });
    }

    initDefaultActiveTabs() {
        const reviewsSource = window.appConfig.hotelInfo?.reviewsSource;

        const allReviews = {
            topHotels: { active: 0 },
            travelata: { active: 1 },
            tripadvisor: { active: 2 },
        };

        this.$reviewsTabs.tabs(allReviews[reviewsSource]);
        this.$reviewsTabs.trigger('tabsactivate');
    }
}

export default HotelPageReviewsView;
